export default "__VITE_ASSET__Dv3ITz_$__"